import { render } from "./CustomTemplate.vue?vue&type=template&id=6c1234e0"
import script from "./CustomTemplate.vue?vue&type=script&lang=js"
export * from "./CustomTemplate.vue?vue&type=script&lang=js"

import "./CustomTemplate.vue?vue&type=style&index=0&id=6c1234e0&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__